import gql from 'graphql-tag'

export default {
  service() {
    return {
      query: gql`
        query Query($serviceId: ID!) {
          service(id: $serviceId) {
            location {
              id
              first_name
              last_name
              order_contact_number
              premise {
                id
                customer_name
                address
                map_link
              }
            }
          }
        }
      `,
      variables() {
        return {
          serviceId: this.$route.params.id
        }
      }
    }
  }
}
